var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5234 24.4219L14.6172 23.3828C14.8906 23.1094 14.8906 22.6719 14.6172 22.4531L6.14062 13.9219L24.8437 13.9219C25.1719 13.9219 25.5 13.6484 25.5 13.2656L25.5 11.7344C25.5 11.4063 25.1719 11.0781 24.8437 11.0781L6.14062 11.0781L14.6172 2.60156C14.8906 2.38281 14.8906 1.94531 14.6172 1.67188L13.5234 0.632814C13.3047 0.359376 12.8672 0.359376 12.5937 0.632814L1.16406 12.0625C0.890624 12.3359 0.890624 12.7187 1.16406 12.9922L12.5937 24.4219C12.8672 24.6953 13.3047 24.6953 13.5234 24.4219Z",
    fill: "#ED1651"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.cb3b7c0901abe4c097a427e1a922de34.svg";
export { ForwardRef as ReactComponent };